import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { PrivacyPage } from './pages/PrivacyPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-5" />} data-id="element-4" />
      </Routes>
    </Router>;
}